'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInvestorPreferencesComplete = exports.isInvestorAffiliationsComplete = exports.isInvestorAccreditationComplete = exports.isInvestorFundQualificationComplete = exports.isInvestorQualificationComplete = exports.isInvestorBasicInformationComplete = undefined;

var _lodash = require('lodash');

var basicInformationRequiredFields = ['firstName', 'lastName', 'email', 'country', 'address', 'companyName'];

var preferencesRequiredFields = ['minimumInvestmentSize', 'averageInvestmentSize', 'preferredListingTypes', 'preferredTransactionTypes', 'preferredAreas'];

var isInvestorBasicInformationComplete = exports.isInvestorBasicInformationComplete = function isInvestorBasicInformationComplete(investorUser) {
  return basicInformationRequiredFields.every(function (field) {
    return !(0, _lodash.isEmpty)(investorUser[field]);
  });
};

var isInvestorQualificationComplete = exports.isInvestorQualificationComplete = function isInvestorQualificationComplete(investorUser) {
  return Boolean(investorUser.accreditationType);
};

var isInvestorFundQualificationComplete = exports.isInvestorFundQualificationComplete = function isInvestorFundQualificationComplete(investorUser) {
  return Boolean(investorUser.intendInvestingFunds);
};

var isInvestorAccreditationComplete = exports.isInvestorAccreditationComplete = function isInvestorAccreditationComplete(investorUser) {
  return investorUser.accreditationStatus !== 'NOT_STARTED';
};

var isInvestorAffiliationsComplete = exports.isInvestorAffiliationsComplete = function isInvestorAffiliationsComplete(investorUser) {
  return Boolean(investorUser.affiliationType);
};

var isInvestorPreferencesComplete = exports.isInvestorPreferencesComplete = function isInvestorPreferencesComplete(investorUser) {
  return preferencesRequiredFields.every(function (field) {
    return !(0, _lodash.isEmpty)(investorUser[field]);
  });
};